import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-12">
      <div className="max-w-5xl mx-auto space-y-16" data-id="element-13">
        {/* Section intro */}
        <h2 className="text-3xl md:text-4xl text-center text-brand-gold font-bold" data-id="element-14">
          Todo esto forma parte del sistema BetIQ
        </h2>

        {/* Bonus #1 */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-15">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-16">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/9y2L1js4T8YfFgLivm368J/Bono_1.jpg" alt="Bono 1: Gestión de Bankroll" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-18" />
            </div>
            <div className="w-full md:w-2/3 space-y-5" data-id="element-19">
              <div data-id="element-20">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-21">
                  <GiftIcon className="w-4 h-4" data-id="element-22" /> BONO #1
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-1" data-id="element-23">
                  Gestión de Bankroll
                </h3>
                <p className="text-lg text-brand-gold" data-id="element-24">
                  Controla tu dinero y aplica BetIQ correctamente
                </p>
              </div>

              <div className="bg-brand-bg rounded-xl p-5 border border-brand-card" data-id="element-25">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-26">
                  <span className="text-brand-muted" data-id="element-27">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-28">$197.00</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-3" data-id="element-29">
                  <span className="text-brand-text font-bold" data-id="element-30">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-31">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-32" />
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bonus #2 */}
        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-33">
          <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-34">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/wZGjgqurw5wKGnh8bxRrbh/Bono_2.jpg" alt="Bono 2: Fundamentos de Apuestas" className="w-full h-auto rounded-xl shadow-lg border border-brand-gold/20" data-id="element-36" />
            </div>
            <div className="w-full md:w-2/3 space-y-5" data-id="element-37">
              <div data-id="element-38">
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold rounded-full text-sm font-bold mb-4 border border-brand-gold/20" data-id="element-39">
                  <GiftIcon className="w-4 h-4" data-id="element-40" /> BONO #2
                </span>
                <h3 className="text-3xl text-brand-text font-heading mb-1" data-id="element-41">
                  Fundamentos de Apuestas
                </h3>
                <p className="text-lg text-brand-gold" data-id="element-42">
                  Entiende el sistema y toma mejores decisiones
                </p>
              </div>

              <div className="bg-brand-bg rounded-xl p-5 border border-brand-card" data-id="element-43">
                <div className="flex justify-between items-center py-2 border-b border-brand-card" data-id="element-44">
                  <span className="text-brand-muted" data-id="element-45">Valor real</span>
                  <span className="text-brand-muted line-through" data-id="element-46">$97.00</span>
                </div>
                <div className="flex justify-between items-center py-2 pt-3" data-id="element-47">
                  <span className="text-brand-text font-bold" data-id="element-48">
                    Con tu acceso hoy
                  </span>
                  <span className="text-brand-green font-bold flex items-center gap-2" data-id="element-49">
                    <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-50" />
                    GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* System reinforcement */}
        <p className="text-center text-xl md:text-2xl text-brand-text font-medium" data-id="element-51">
          No es información suelta. Es un sistema completo.
        </p>

        {/* Final quote */}
        <div className="text-center space-y-2 pt-4" data-id="element-52">
          <p className="text-xl md:text-2xl text-brand-muted italic leading-relaxed" data-id="element-53">
            "La diferencia entre apostar y analizar no es talento. Es tener un
            sistema."
          </p>
          <p className="text-brand-gold font-bold text-lg" data-id="element-54">— BetIQ</p>
        </div>
      </div>
    </section>;
}